<template>
  <v-layout
    row
    align-content-space-between
    align-center
    pa-2
    my-1
    :class="{
      'grey lighten-3': index % 2 != 0,
      'pending-approval': !shift.approved
    }"
  >
    <v-flex shrink class="ma-1" align-self-start>
      <v-layout row>
        <v-icon>
          person
        </v-icon>
      </v-layout>
      <v-layout row>
        <v-icon
          v-if="shift.tradePending && user.role != 'client'"
          color="primary"
        >
          sync
        </v-icon>
      </v-layout>
    </v-flex>

    <v-flex xs4>
      <ul class="unstyled">
        <li class="body-2">
          {{ shift.startDatetime | moment("dddd, MMMM DD") }}
        </li>
        <li>
          <router-link
            :to="{ name: 'shiftDetail', params: { shiftId: shift.id } }"
            class="unstyled-link"
            target="_blank"
          >
            <span
              class="title"
              :class="shift.workerName ? 'green--text' : 'red--text'"
              >{{ shift.shiftRole }}</span
            >
          </router-link>
          <v-tooltip top>
            <v-icon
              large
              v-if="shift.employeeAbsent"
              color="warning"
              slot="activator"
            >
              warning
            </v-icon>
            <span>Employee was absent</span>
          </v-tooltip>
        </li>
        <li v-if="shift.workerName" class="title subtle">
          <EmployeeName
            :name="shift.workerName"
            :employeeId="shift.userId"
            :link="user.clientOrHigher"
          />
        </li>
        <li class="subtle body-2">
          {{ shift.startDatetime | moment("h:mma") }} -
          {{ shift.endDatetime | moment("h:mma") }}
        </li>
        <li v-if="user.managerOrHigher" class="subtle body-2">
          <router-link
            :to="{ name: 'shiftDetail', params: { shiftId: shift.id } }"
            style="color: inherit;"
            >{{ shift.location }}</router-link
          >
        </li>
        <li v-else class="subtle body-2">
          <router-link
            :to="{ name: 'shiftDetail', params: { shiftId: shift.id } }"
            style="color: inherit;"
            >{{ shift.location }}</router-link
          >
        </li>
      </ul>
    </v-flex>

    <v-flex xs4 class="mx-2">
      <div v-if="!shift.approved" class="text-xs-center title mb-2">
        Pending Approval
      </div>
      <v-layout column>
        <v-flex>
          <v-btn
            v-if="user.role == 'employee'"
            :to="{ name: 'shiftDetail', params: { shiftId: shift.id } }"
            class="no-margin"
            color="primary"
          >
            <v-icon left>
              visibility
            </v-icon>
            View
          </v-btn>
          <v-btn
            v-else
            :to="{ name: 'shiftDetail', params: { shiftId: shift.id } }"
            class="no-margin"
            color="primary"
          >
            <v-icon left>
              create
            </v-icon>
            Edit
          </v-btn>
          <v-btn disabled color="success">
            <v-icon left>
              remove_circle
            </v-icon>
            Contact
          </v-btn>
        </v-flex>

        <v-flex v-if="user.role == 'client'">
          <ClientCancelShiftButton :shift="shift" redirectTo="/calendar/list" />
        </v-flex>

        <v-flex v-if="!shift.userId && user.managerOrHigher">
          <v-dialog v-model="deleteDialog" full-width max-width="400">
            <v-btn
              slot="activator"
              block
              color="error"
              class="shift-list__delete"
            >
              <v-icon left>
                cancel
              </v-icon>
              Delete
            </v-btn>

            <v-card>
              <v-card-text class="text-xs-center">
                <h2 class="headline">This shift is part of a series</h2>
                <div class="mb-1">
                  <v-btn block color="error" @click="deleteShift(false, false)">
                    Delete only this shift
                  </v-btn>
                </div>
                <div class="mb-1">
                  <v-btn block color="error" @click="deleteShift(false, true)">
                    Delete this and following shifts
                  </v-btn>
                </div>
                <div class="mb-1">
                  <v-btn block color="error" @click="deleteShift(true, false)">
                    Delete all shifts in this series
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-flex>

        <v-flex>
          <BonusView :shift="shift" type="travel" :role="user.role" />
          <BonusView :shift="shift" type="callIn" :role="user.role" />
          <BonusView :shift="shift" type="straight" :role="user.role" />
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs4>
      <div v-if="shift.details" class="subtle">
        <p class="body-1">
          <span class="font-weight-bold text-uppercase">Shift Details: </span
          >{{ shift.details }}
        </p>
      </div>

      <div class="unstyled subtle">
        <BonusList :shift="shift" :role="user.role" />
      </div>

      <div v-if="user.managerOrHigher">
        <div v-if="shift.employeeNotes">
          <p class="body-1">
            <span class="font-weight-bold text-uppercase">Employee notes: </span
            >{{ shift.employeeNotes }}
          </p>
        </div>
        <div v-if="shift.clientNotes">
          <p class="body-1">
            <span class="font-weight-bold text-uppercase">Client notes: </span
            >{{ shift.clientNotes }}
          </p>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import ClientCancelShiftButton from "./client-cancel-shift-button.vue";

export default {
  props: ["shift", "index"],
  components: { ClientCancelShiftButton },
  computed: {
    ...mapState("userAuth", ["user"]),
    ...mapState("shifts", ["notes"])
  },
  created() {
    this.setUp();
  },
  watch: {},
  data: function() {
    return {
      example: "test",
      deleteDialog: false
    };
  },
  methods: {
    exampleMethod() {},
    deleteShift(allRecurring, onlyAfter) {
      this.$store
        .dispatch("shifts/destroy", {
          shiftId: this.shift.id,
          allRecurring: allRecurring,
          onlyAfter: onlyAfter
        })
        .finally(res => {
          this.$router.push("/calendar/list");
        });
    },
    setUp() {
      this.$store.dispatch("shifts/getNotes", { shiftId: this.shift.id });
    }
  }
};
</script>

<style scoped>
.shift-list__delete {
  max-width: 255px;
}
</style>
